const styles = () => ({
  addHeadline: {
    fontSize: 18,
  }
});

export default styles;